import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import BlockArea from 'features/BlockArea';
import ServiceBlock from 'features/ServiceBlock';
import Breadcrumbs from 'components/breadcrumbs';
import { FlexContainerCentered } from 'components/flex';
import { PageContent } from '../components';
import ServicePageMenuBlock from './components/ServicePageMenuBlock';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { sizes } from 'style/media';
import { FilterByCounty } from 'utils';
import {
    SubMenuContainerDiv,
    SubMenuContainerItem,
    SubMenuContainerLink,
    Underlined,
    SubMenuTopTitle,
    RowLeft,
    LeftMenuContainerUl,
    ColumnLeft,
    ColumnRight,
    BreadcrumbsMobileStyle,
    BreadcrumbsMobileStyleCell,
    BreadcrumbsMobileStyleLink,
    ArrowLeft
} from './components/ServicePageContainer';
import CollapsableSubMenuWrapper from './components/CollapsibleSubMenu/CollapsableSubMenuWrapper';

class ServicePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            renderRootPages: [],
            renderSubPages: [],
            filter: this.props.filter.selectedId,
            filteredBlockArea: this.props.blockContentArea,
            scrollPosition: window.pageYOffset,
            clickedLeftMenu: false,
            open: false,
            currentPageName: '',
            parentName: '',
            children: []
        };
        this.rootCountyId = props.app.rootCountyId;
        this.serviceNav = props.app.serviceNav;
        this.currentPage = props.currentPage;
        this.filter = props.filter;
        const { selectedId, countyCategories } = this.filter;
        this.filteredServiceNav = FilterByCounty(this.serviceNav, selectedId, this.rootCountyId, countyCategories);
        this.Scroll = this.Scroll.bind(this);
    }

    Scroll = (url, e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ scrollPosition: window.pageYOffset, clickedLeftMenu: true }, () => {
            this.props.history.push(url);
        });
    };

    togglePanel(e) {
        this.setState({ open: !this.state.open });
    }

    ItemExists = newSubPage =>
        this.state.renderSubPages.find(subpage => subpage.linkUrl === newSubPage.linkUrl);

    ListsAreIdentical = (list1, list2) => JSON.stringify(list1) === JSON.stringify(list2);

    RenderSubPages = () => {
        const { subPages, filter } = this.props;
        const { renderSubPages } = this.state;
        var renderSub = [];

        if (subPages) {
            subPages.forEach(item => {
                item.subPages.forEach(sp => {
                    const { name, linkUrl, pageCategories } = sp;
                    if (
                        !this.ItemExists(sp) &&
                        pageCategories &&
                        pageCategories.includes(filter.selectedId)
                    ) {
                        renderSub.push({ Name: name, LinkUrl: linkUrl });
                    }
                });
            });
        }

        if (!this.ListsAreIdentical(renderSubPages, renderSub)) {
            this.setState({ renderSubPages: renderSub });
        }
    };

    getSideMenuItems(filterdServiceNav) {
        const findTargetPageName = function (siteMap, currentPageName) {
            // This version returns the currentPageName if there is a match in the site map. But if that item has no children, it returns its parent.
            let targetPageName = null;

            const searchTree = function (currentItem, parentName) {
                if (currentItem.name === currentPageName) {
                    if (currentItem.childNavigationLinks && currentItem.childNavigationLinks.length > 0) {
                        targetPageName = currentItem.name;
                    } else {
                        targetPageName = parentName;
                    }
                } else if (currentItem.childNavigationLinks) {
                    currentItem.childNavigationLinks.forEach(child => searchTree(child, currentItem.name));
                }
            };

            siteMap.forEach(item => searchTree(item, null));

            return targetPageName;

            /* The following alternate version returns the parent name by default, if root returns itself.
            let parentName = null;
      
            const findParent = function(currentItem) {
              if (currentItem.childNavigationLinks) {
                const childMatch = currentItem.childNavigationLinks.find(
                  child => child.name === currentPageName
                );
                if (childMatch) {
                  parentName = currentItem.name;
                } else {
                  currentItem.childNavigationLinks.forEach(child => findParent(child));
                }
              }
            };
      
            siteMap.forEach(item => findParent(item));
      
            return parentName !== null ? parentName : currentPageName;
            */
        };

        const targetPageName = findTargetPageName(this.serviceNav, this.currentPage.header);

        function findSideMenuItems(siteMap, targetPageName) {
            let pageAndChildren = [];

            const search = function (item) {
                if (item.name === targetPageName) {
                    pageAndChildren.push({ name: item.name, url: item.url ? item.url[0] : '#' });
                    if (item.childNavigationLinks && item.childNavigationLinks.length > 0) {
                        item.childNavigationLinks.forEach(child => {
                            pageAndChildren.push({ name: child.name, url: child.url ? child.url[0] : '#' });
                        });
                    }
                    return;
                } else if (item.childNavigationLinks && item.childNavigationLinks.length > 0) {
                    item.childNavigationLinks.forEach(child => search(child));
                }
            };

            siteMap.forEach(item => search(item));

            return pageAndChildren;
        }


        const sideMenuItems = findSideMenuItems(filterdServiceNav, targetPageName);

        return sideMenuItems;
    }

    componentDidMount() {
        const {
            heroContentArea,
            topRootPageUrl,
            rootCategoryPages,
            filter,
            subRootCategoryPages,
            breadcrumbs,
            subPages,
            blockContentArea
        } = this.props;
       

        let savedState = null;
        let savedProps = null;
        var renderSub = [];
        if (
            localStorage.getItem('savedState') !== null &&
            localStorage.getItem('savedProps') !== null
        ) {
            savedState = JSON.parse(localStorage.getItem('savedState'));
            savedProps = JSON.parse(localStorage.getItem('savedProps'));
        }

        /* Code below used to behave differently depending on whether the page loaded prior had a hero or not,
         * which is not the case anymore. Old code structure will be kept for now */
        if (savedState !== null && savedProps !== null) {
            if (savedState.clickedLeftMenu) {
                if (
                    (heroContentArea && savedProps.heroContentArea) ||
                    (!heroContentArea && !savedProps.heroContentArea) ||
                    (heroContentArea && !savedProps.heroContentArea) ||
                    (!heroContentArea && savedProps.heroContentArea)
                ) {
                    window.scrollTo(0, savedState.scrollPosition);
                } else {
                    window.scrollTo(0, 0);
                }
            }
        }

        var keyArray = [];
        const rootLevel = topRootPageUrl ? topRootPageUrl.split('/').length : 0;

        if (rootCategoryPages) {
            var rootCatPagesJson = JSON.parse(rootCategoryPages);
            var renderRoot = [];

            rootCatPagesJson.forEach(item => {
                item.category.forEach(cat => {
                    var key = item.Name + item.LinkUrl;

                    if (filter.selectedId === cat && !keyArray.includes(key)) {
                        renderRoot.push({
                            Name: item.Name,
                            LinkUrl: item.LinkUrl,
                            HideInMenu: item.HideInMenu
                        });
                        keyArray.push(key);
                    }
                });
            });
            this.setState({ renderRootPages: renderRoot });
        }

        if (subRootCategoryPages) {
            var subRootCatPagesJson = JSON.parse(subRootCategoryPages);
            keyArray = [];

            if (breadcrumbs.length === rootLevel) {
                subRootCatPagesJson.forEach(sub => {
                    subPages.forEach(item => {
                        item.subPages.forEach(sp => {
                            if (sp.linkUrl === sub.LinkUrl) {
                                sub.category.forEach(cat => {
                                    var key = sp.name + sp.linkUrl;

                                    if (
                                        filter.selectedId === cat &&
                                        !keyArray.includes(key) &&
                                        !this.ItemExists(sp)
                                    ) {
                                        renderSub.push({ Name: sp.name, LinkUrl: sp.linkUrl });
                                        keyArray.push(key);
                                    }
                                });
                            }
                        });
                    });
                });
            } else if (breadcrumbs.length > rootLevel) {
                rootCatPagesJson.forEach(page => {
                    if (page.LinkUrl === breadcrumbs[rootLevel - 1].url) {
                        subRootCatPagesJson.forEach(sub => {
                            if (sub.LinkUrl.includes(breadcrumbs[rootLevel - 1].url)) {
                                sub.category.forEach(cat => {
                                    var key = sub.Name + sub.LinkUrl;

                                    if (
                                        filter.selectedId === cat &&
                                        !keyArray.includes(key) &&
                                        !this.ItemExists(sub)
                                    ) {
                                        renderSub.push({ Name: sub.Name, LinkUrl: sub.LinkUrl });
                                        keyArray.push(key);
                                    }
                                });
                            }
                        });
                    }
                });
            }
            this.setState({ renderSubPages: renderSub });
        }

        let foundContent = false;
        if (blockContentArea && blockContentArea.length > 0) {
            blockContentArea.forEach(block => {
                if (block.blockType !== 'MenuBlock') {
                    block.category.forEach(cat => {
                        if (cat === filter.selectedId) {
                            foundContent = true;
                        }
                    });
                }
            });
        }

        let newContentAreaBlock = [];
        if (foundContent) {
            blockContentArea.forEach(block => {
                if (!block.isFallback) {
                    block.category.forEach(cat => {
                        if (cat === filter.selectedId) {
                            newContentAreaBlock.push(block);
                        }
                    });
                }
            });
        } else {
            if (blockContentArea) {
                blockContentArea.forEach(block => {
                    if (block.isFallback) {
                        newContentAreaBlock.push(block);
                    }
                });
            }
        }
        this.setState({ filteredBlockArea: newContentAreaBlock });

        if (this.state.renderSubPages.length === 0 && subPages.length > 0) {
            this.RenderSubPages();
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const {
            filter,
            rootCategoryPages,
            subRootCategoryPages,
            topRootPageUrl,
            breadcrumbs,
            subPages,
            blockContentArea
        } = this.props;
        if (this.state.scrollPosition > 0 || prevState.scrollPosition > 0) {
            window.scrollTo(0, this.state.scrollPosition);
        }    
        
        if (filter.selectedId !== this.state.filter) {
           
            this.setState({ filter: filter.selectedId });
            this.filteredServiceNav = FilterByCounty(this.serviceNav, filter.selectedId, this.rootCountyId, filter.countyCategories)
            const rootLevel = topRootPageUrl ? topRootPageUrl.split('/').length : 0;
            var renderSub = [];

            if (
                rootCategoryPages !== null &&
                rootCategoryPages !== '' &&
                subRootCategoryPages !== null &&
                subRootCategoryPages !== ''
            ) {
                var rootCatPagesJson = JSON.parse(rootCategoryPages);
                var subRootCatPagesJson = JSON.parse(subRootCategoryPages);
                var renderRoot = [];
                var keyArray = [];

                rootCatPagesJson.forEach(item => {
                    item.category.forEach(cat => {
                        var key = item.Name + item.LinkUrl;

                        if (filter.selectedId === cat && !keyArray.includes(key)) {
                            renderRoot.push({ Name: item.Name, LinkUrl: item.LinkUrl });
                            keyArray.push(key);
                        }
                    });
                });

                if (renderRoot !== this.state.renderRootPages) {
                    this.setState({ renderRootPages: renderRoot });
                }

                keyArray = [];
                if (breadcrumbs.length === rootLevel) {
                    subRootCatPagesJson.forEach(sub => {
                        subPages.forEach(item => {
                            item.subPages.forEach(sp => {
                                if (sp.linkUrl === sub.LinkUrl) {
                                    sub.category.forEach(cat => {
                                        var key = sp.name + sp.linkUrl;

                                        if (
                                            filter.selectedId === cat &&
                                            !keyArray.includes(key) &&
                                            !this.ItemExists(sp)
                                        ) {
                                            renderSub.push({ Name: sp.name, LinkUrl: sp.linkUrl });
                                            keyArray.push(key);
                                        }
                                    });
                                }
                            });
                        });
                    });
                    this.setState({ renderSubPages: renderSub });
                } else if (breadcrumbs.length > rootLevel) {
                    rootCatPagesJson.forEach(page => {
                        if (page.LinkUrl === breadcrumbs[rootLevel - 1].url) {
                            subRootCatPagesJson.forEach(sub => {
                                if (sub.LinkUrl.includes(breadcrumbs[rootLevel - 1].url)) {
                                    sub.category.forEach(cat => {
                                        var key = sub.Name + sub.LinkUrl;

                                        if (
                                            filter.selectedId === cat &&
                                            !keyArray.includes(key) &&
                                            !this.ItemExists(sub)
                                        ) {
                                            renderSub.push({ Name: sub.Name, LinkUrl: sub.LinkUrl });
                                            keyArray.push(key);
                                        }
                                    });
                                }
                            });
                        }
                    });
                    this.setState({ renderSubPages: renderSub });
                }
            }

            let foundContent = false;
            if (blockContentArea && blockContentArea.length > 0) {
                blockContentArea.forEach(block => {
                    if (block.blockType !== 'MenuBlock') {
                        block.category.forEach(cat => {
                            if (cat === filter.selectedId) {
                                foundContent = true;
                            }
                        });
                    }
                });
            }

            let newContentAreaBlock = [];
            if (foundContent) {
                blockContentArea.forEach(block => {
                    if (!block.isFallback) {
                        block.category.forEach(cat => {
                            if (cat === filter.selectedId) {
                                newContentAreaBlock.push(block);
                            }
                        });
                    }
                });
            } else {
                if (blockContentArea) {
                    blockContentArea.forEach(block => {
                        if (block.isFallback) {
                            newContentAreaBlock.push(block);
                        }
                    });
                }
            }
            this.setState({ filteredBlockArea: newContentAreaBlock });

            if (renderSub.length === 0) {
                this.RenderSubPages();
            }
        }
    }

    componentWillUnmount() {
        localStorage.setItem('savedState', JSON.stringify(this.state));
        localStorage.setItem('savedProps', JSON.stringify(this.props));
    }

    heroBlockToShow = () => {
        const { filter, heroContentArea } = this.props;
        const nonFallback = [];
        for (var i = 0; i < heroContentArea.length; i++) {
            if (heroContentArea[i].categories.filter(x => x === filter.selectedId).length !== 0)
                nonFallback.push(heroContentArea[i]);
        }
        if (nonFallback.length) return nonFallback;
        else {
            for (var x = 0; x < heroContentArea.length; x++) {
                if (heroContentArea[x].categories.filter(y => y === 2).length !== 0)
                    nonFallback.push(heroContentArea[x]);
            }
            return nonFallback;
        }
    };

    render() {
        if (!this.props) return null;
        const {
            heroContentArea,
            rootCategoryPages,
            isTopRoot,
            showSubMenu,
            servicePageUrl,
            breadcrumbs,
            displayBreadcrumbs,
            showLeftSideMenu,
            buttonText,
            buttonLink,
            buttonLinkRef
        } = this.props;
        const gradientOpacity = 0.2;
        let hasMenuBlock = false;
        let menuBlock = null;

        const sideMenuItems = this.getSideMenuItems(this.filteredServiceNav);

        const uniqueSubPages = [];
        this.state.renderSubPages.forEach((value, key) => {
            if (!uniqueSubPages.some(exisitngSubPage => exisitngSubPage.LinkUrl === value.LinkUrl)) {
                uniqueSubPages.push(value);
            }
        });

        if (this.state.filteredBlockArea && this.state.filteredBlockArea.length > 0) {
            this.state.filteredBlockArea.forEach(block => {
                if (block.blockType === 'MenuBlock') {
                    hasMenuBlock = true;
                    menuBlock = block;
                } else if (block.blockType === 'CountyContentAreaBlock') {
                    if (!block.isFallback) {
                        block.category.forEach(cat => {
                            if (this.props.filter.selectedId === cat) {
                                block.blockContentArea.forEach(contentAreaBlock => {
                                    if (contentAreaBlock.blockType === 'MenuBlock' && !hasMenuBlock) {
                                        hasMenuBlock = true;
                                        menuBlock = contentAreaBlock;
                                    }
                                });
                            }
                        });
                    } else if (block.blockContentArea !== null) {
                        block.blockContentArea.forEach(contentAreaBlock => {
                            if (contentAreaBlock.blockType === 'MenuBlock' && !hasMenuBlock) {
                                hasMenuBlock = true;
                                menuBlock = contentAreaBlock;
                            }
                        });
                    }
                }
            });
        }

        const subMenuMobile = true;

        if (window.innerWidth >= sizes.desktop) {
            return (
                <div>
                    <Fragment>
                        {heroContentArea ? (
                            <BlockArea
                                propertyName="heroContentArea"
                                contentarea={this.heroBlockToShow()}
                                opacity={gradientOpacity}
                                nomargin
                            />
                        ) : (
                            ''
                        )}

                        {showSubMenu && rootCategoryPages && (
                            <SubMenuContainerDiv>
                                {this.state.renderRootPages.map((root, i) => {
                                    if (root.HideInMenu) return null;
                                    return (
                                        <SubMenuContainerItem key={i}>
                                            <SubMenuTopTitle style={{ textAlign: 'center' }}>
                                                <SubMenuContainerLink nounderline to={root.LinkUrl}>
                                                    {root.Name}
                                                    {servicePageUrl.includes(root.LinkUrl) && !isTopRoot ? (
                                                        <Underlined />
                                                    ) : (
                                                        ''
                                                    )}
                                                </SubMenuContainerLink>
                                            </SubMenuTopTitle>
                                        </SubMenuContainerItem>
                                    );
                                })}
                            </SubMenuContainerDiv>
                        )}

                        <FlexContainerCentered alignItems="flex-start" marginbottom="1em">
                            <PageContent
                                className="PageContentClass"
                                hasrelated={false}
                                style={{ paddingTop: '1rem' }}>
                                <div
                                    style={{
                                        height: '100%',
                                        maxWidth: '100%'
                                    }}>
                                    {breadcrumbs && displayBreadcrumbs && (
                                        <Breadcrumbs breadcrumbs={breadcrumbs} margin="0 0 1em 0" />
                                    )}
                                </div>

                                {showLeftSideMenu ? (
                                    <RowLeft>
                                        <ColumnLeft hasMenuBlock={hasMenuBlock}>
                                            <LeftMenuContainerUl className="side-menu">
                                                {sideMenuItems.map(item => (
                                                    <li
                                                        className={`side-menu__link ${item.name === this.props.currentPage.header
                                                            ? 'side-menu__link--current'
                                                            : ''
                                                            }`}
                                                        key={item.name}>
                                                        <a href={item.url}>{item.name}</a>
                                                    </li>
                                                ))}
                                            </LeftMenuContainerUl>
                                        </ColumnLeft>
                                        {hasMenuBlock && (
                                            <ColumnRight hasMenuBlock={hasMenuBlock} style={{ marginTop: '1rem' }}>
                                                <ServicePageMenuBlock menuBlock={menuBlock} filter={this.props.filter} />
                                            </ColumnRight>
                                        )}
                                    </RowLeft>
                                ) : (
                                    ''
                                )}
                            </PageContent>
                        </FlexContainerCentered>
                    </Fragment>
                    {this.state.filteredBlockArea && (
                        <Fragment>
                            <ServiceBlock
                                blockName="serviceBlock"
                                contentarea={this.state.filteredBlockArea}
                                buttonText={buttonText}
                                buttonLink={buttonLink}
                                buttonLinkRef={buttonLinkRef}
                                opacity={gradientOpacity}
                                showMenuBlock={hasMenuBlock && !showLeftSideMenu}
                            />
                        </Fragment>
                    )}
                </div>
            );
        } else {
            return (
                <div>
                    <Fragment>
                        <div
                            style={{
                                height: '100%',
                                maxWidth: '100%'
                            }}>
                            {breadcrumbs && displayBreadcrumbs && (
                                <BreadcrumbsMobileStyle>
                                    <BreadcrumbsMobileStyleCell>
                                        <ArrowLeft />
                                        <BreadcrumbsMobileStyleLink
                                            nounderline
                                            to={breadcrumbs[breadcrumbs.length - 2].url}>
                                            {breadcrumbs[breadcrumbs.length - 2].name}
                                        </BreadcrumbsMobileStyleLink>
                                    </BreadcrumbsMobileStyleCell>
                                </BreadcrumbsMobileStyle>
                            )}
                        </div>
                        {heroContentArea ? (
                            <BlockArea
                                propertyName="heroContentArea"
                                subMenuMobile={subMenuMobile}
                                contentarea={this.heroBlockToShow()}
                                opacity={gradientOpacity}
                                nomargin
                            />
                        ) : (
                            <div style={{ padding: '1rem' }} />
                        )}
                        {showSubMenu &&
                            <div>
                                {this.props.currentPage.servicePageUrl.split('/').length > 3 ? (
                                    <CollapsableSubMenuWrapper
                                        serviceNav={this.filteredServiceNav.find(item => item.name === this.props.currentPage.breadcrumbs[1].name)}
                                        currentPageUrl={this.props.currentPage.servicePageUrl}
                                        currentPageHeader={this.props.currentPage.breadcrumbs[2].name}
                                    />
                                ) : (
                                    <CollapsableSubMenuWrapper
                                        serviceNav={this.filteredServiceNav.find(item => item.name === this.props.currentPage.breadcrumbs[1].name)}
                                        currentPageUrl={this.props.currentPage.servicePageUrl}
                                        currentPageHeader={this.props.currentPage.header}
                                    />
                                )}
                            </div>
                        }
                    </Fragment>
                    {this.state.filteredBlockArea && (
                        <Fragment>
                            <ServiceBlock
                                blockName="serviceBlock"
                                contentarea={this.state.filteredBlockArea}
                                buttonText={buttonText}
                                buttonLink={buttonLink}
                                buttonLinkRef={buttonLinkRef}
                                opacity={gradientOpacity}
                                showMenuBlock={true}
                                subMenuMobile={true}
                            />
                        </Fragment>
                    )}
                    {/*showLeftSideMenu && (
            <Fragment>
              <FlexContainerCentered alignItems="flex-start" marginbottom="2.5em">
                <PageContent
                  className="PageContentClass"
                  hasrelated={false}
                  style={{ paddingLeft: '1rem', paddingTop: '1.5rem' }}>
                  <LeftMenuContainerUl>
                    <div>
                      {breadcrumbs.length < rootLevel
                        ? <SubMenuPageTitle1>{breadcrumbs[breadcrumbs.length - 1].name}</SubMenuPageTitle1>
                        : breadcrumbs.length === rootLevel
                          ? <SubMenuPageTitle1>{breadcrumbs[breadcrumbs.length - 1].name}</SubMenuPageTitle1>
                          : <SubMenuPageTitle1>{breadcrumbs[breadcrumbs.length - 2].name}</SubMenuPageTitle1>
                      }
                      <SubMenuPageTitleUnderline />
                    </div>
                    {!isTopRoot
                      ? this.state.renderSubPages.map((sub, i) => {
                        return (
                          <div key={i}>
                            <LeftMenuContainerLi key={i}>
                              {breadcrumbs[breadcrumbs.length - 1].name !== sub.Name ? (
                                <SubMenuPageSmallText>
                                  <CustomLink href={sub.LinkUrl}>{sub.Name}</CustomLink>
                                </SubMenuPageSmallText>
                              ) : (
                                  <SubMenuPageSmallText>
                                    <CustomLink href={sub.LinkUrl} style={{ fontWeight: 'bolder' }}>
                                      {sub.Name}
                                    </CustomLink>
                                  </SubMenuPageSmallText>
                                )}
                            </LeftMenuContainerLi>
                            {i + 1 < this.state.renderSubPages.length ? (
                              <LeftMenuContainerLiUnderline />
                            ) : (
                              ''
                            )}
                          </div>
                        );
                      })
                      : this.state.renderRootPages.map((root, i) => {
                        return (
                          <div key={i}>
                            <LeftMenuContainerLi key={i}>
                              <SubMenuPageSmallText>
                                <CustomLink href={root.LinkUrl}>{root.Name}</CustomLink>
                              </SubMenuPageSmallText>
                            </LeftMenuContainerLi>
                            {i + 1 < this.state.renderRootPages.length ? (
                              <MobileMenuContainerLiUnderline />
                            ) : (
                              ''
                            )}
                          </div>
                        );
                      })
                    }
                  </LeftMenuContainerUl>
                </PageContent>
              </FlexContainerCentered>
            </Fragment>
          )*/}
                </div>
            );
        }
    }
}

const mapStateToProps = ({ filter, page, app }) => ({
    filter: {
        selectedId: filter.selected.id,
        categoryList: filter.categoryList,
        countyCategories: filter.categoryList
    },
    app: {
        serviceNav: app.serviceNav,
        rootCountyId: app.settings.rootCounty
    },
    forceMode: filter.forceMode,
    currentPage: page.page,
    currentPageId: page.currentId
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ServicePage);
